import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { register, clearError } from '../../store/slices/authSlice';
import { toast } from 'react-toastify';
import useIsMobile from '../../hooks/useIsMobile';

export default function Register() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, user } = useSelector((s) => s.auth);
  const isMobile = useIsMobile();
  const [form, setForm] = useState({ name: '', email: '', phone: '', password: '' });

  useEffect(() => { if (user) navigate('/'); }, [user, navigate]);
  useEffect(() => { if (error) { toast.error(error); dispatch(clearError()); } }, [error, dispatch]);

  const handleSubmit = (e) => { e.preventDefault(); dispatch(register(form)); };
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div style={S.page}>
      <div style={S.card}>
        <div style={S.topBar} />
        <div style={S.inner}>
          <img src="/logo.svg" alt="Bhadralok" style={{ height: '48px', width: 'auto', display: 'block', margin: '0 auto 8px' }} />
          <p style={S.tagline}>Cha · Adda · Identity</p>

          <h2 style={S.title}>CREATE ACCOUNT</h2>
          <p style={S.sub}>Join the Bhadralok community</p>

          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '10px' }}>
              <div>
                <label style={S.label}>First Name</label>
                <input style={S.input} type="text" placeholder="Amit" value={form.name} onChange={set('name')} required />
              </div>
              <div>
                <label style={S.label}>Phone</label>
                <input style={S.input} type="tel" placeholder="9999999999" value={form.phone} onChange={set('phone')} />
              </div>
            </div>

            <label style={S.label}>Email Address</label>
            <input style={S.input} type="email" placeholder="your@email.com" value={form.email} onChange={set('email')} required />

            <label style={S.label}>Password</label>
            <input style={S.input} type="password" placeholder="Min 6 characters" value={form.password} onChange={set('password')} required minLength={6} />

            <button className="btn-primary" type="submit" disabled={loading} style={{ width: '100%', justifyContent: 'center', marginTop: '4px' }}>
              {loading ? 'CREATING...' : 'CREATE ACCOUNT →'}
            </button>
          </form>

          <p style={S.switch}>Already have an account? <Link to="/login" style={{ color: 'var(--red)', fontWeight: 700, textDecoration: 'underline' }}>Sign in</Link></p>

          <div style={S.benefits}>
            <p style={S.benefitsTitle}>MEMBER BENEFITS</p>
            {['Exclusive discounts & offers', 'Order tracking & history', 'Wishlist & early access'].map((b) => (
              <p key={b} style={S.benefit}><span style={{ color: 'var(--green)' }}>✓</span> {b}</p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

const S = {
  page:         { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--black)', padding: '20px' },
  card:         { background: '#fff', width: '100%', maxWidth: '440px' },
  topBar:       { height: '4px', background: 'linear-gradient(90deg,var(--red),var(--gold),var(--green))' },
  inner:        { padding: '32px' },
  logo:         { fontFamily: 'var(--font-display)', fontSize: '28px', letterSpacing: '4px', textAlign: 'center', marginBottom: '4px' },
  tagline:      { fontFamily: 'var(--font-script)', fontSize: '16px', color: 'var(--gold)', textAlign: 'center', marginBottom: '24px' },
  title:        { fontFamily: 'var(--font-display)', fontSize: '22px', letterSpacing: '2px', marginBottom: '4px' },
  sub:          { fontSize: '13px', color: '#888', marginBottom: '20px' },
  label:        { display: 'block', fontSize: '10px', fontWeight: 700, letterSpacing: '1px', textTransform: 'uppercase', color: '#777', marginBottom: '5px', marginTop: '2px' },
  input:        { width: '100%', border: '1.5px solid var(--border)', background: 'var(--offwhite)', padding: '10px 13px', fontFamily: 'var(--font-body)', fontSize: '14px', outline: 'none', marginBottom: '12px', boxSizing: 'border-box' },
  switch:       { textAlign: 'center', fontSize: '13px', color: '#888', margin: '16px 0' },
  benefits:     { background: 'var(--light)', padding: '12px 14px', borderLeft: '3px solid var(--gold)' },
  benefitsTitle:{ fontSize: '9px', fontWeight: 700, letterSpacing: '1.5px', textTransform: 'uppercase', color: 'var(--charcoal)', marginBottom: '8px' },
  benefit:      { fontSize: '12px', color: '#555', marginBottom: '4px' },
};
